import { BehaviorSubject } from "rxjs";
import { AuftragEx } from "src/app/api/model/model";
import { WorkflowStatus, Unterschrift, Workflow, AuftragsFormular, Checkliste } from "src/app/api/model/swagger-model";

export interface BildVO {
    src: string;
    datum?: string;
    nummer?: number;
    guid: string;
    bezeichnung: string;
}

export interface ButtonVO {
    text: string;
    icon: string;
    color: string;
    workflowStatus: WorkflowStatus;
}

export class UnterschriftVO {
    rolle = '';
    erforderlich = new BehaviorSubject<boolean>(false);
    vorhanden = false;
    name = '';
    bild = '';
    unterschrift = new BehaviorSubject<Unterschrift>(null);
    hidden?: boolean;
    height?: string;

    getRolleLang() {
        switch (this.rolle) {
            case 'ERZ':
                return 'Erzeuger';
            case 'BEF':
                return 'Beförderer';
            case 'ENT':
                return 'Entsorger';
        }

        return '';
    }
}

export interface StatusMeldenResult {
    erfolgreich: boolean;
    detectChanges: boolean;
    abbruch: boolean;
}

/** Ergebnis der Pflichtdruck-Prüfung beim Abschließen */
export interface PflichtdruckErgebnis {
    /** Der Fahrer hat abgebrochen, der Status darf nicht gemeldet werden */
    abbruch: boolean;
    /** Es wurde ein Dialog angezeigt. Die Rückfrage "wirklich senden?" ist dann nicht mehr nötig */
    dialogAngezeigt: boolean;
    /** Gesetzt, wenn ohne Druck abgeschlossen wird: Grund für ReCoLog */
    uebersprungenGrund: string;
}

/** Ergebnis des Druck-Dialogs beim Pflichtdruck */
export interface PflichtdruckDruckErgebnis {
    gedruckt: boolean;
    /** Fehlertext, wenn nicht gedruckt werden konnte. NULL, wenn der Fahrer den Dialog geschlossen hat */
    fehler: string;
}
